import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(staitc-page)/agb/Agb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
